import React, { useContext, useEffect } from "react";
import { Form, Formik } from "formik";
import { Button, Col, Row, Input } from "components/bootstrap";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { StyledTitle } from "./StyledWizardComponents";
import { ForwarderWizardContext } from "./ForwarderWizardProvider";
import ForwardersStore, { ForwardersActions } from "../stores/ForwardersStore";
const ConfigureForwarderStep = ({ onStepComplete, forwarderId = void 0 }) => {
  const { selectedForwarder, setSelectedForwarder } = useContext(ForwarderWizardContext);
  const { forwardersPendingConfiguration } = useStore(ForwardersStore);
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    if (forwarderId && !selectedForwarder) {
      if (forwardersPendingConfiguration.length === 0) {
        ForwardersActions.listPendingConfiguration({});
      }
      const forwarder = forwardersPendingConfiguration.find((f) => f.id === forwarderId);
      if (forwarder) {
        setSelectedForwarder(forwarder);
      }
    }
  }, [forwarderId, selectedForwarder, forwardersPendingConfiguration, setSelectedForwarder]);
  if (forwarderId && !selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, "Please wait...");
  }
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, "Please select a Forwarder before continuing to this step.");
  }
  const handleSubmit = (values, { setSubmitting }) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_CONFIGURE_FORWARDER_SAVED, {
      app_pathname: "forwarder",
      app_section: "forwarder-create",
      app_action_value: "save"
    });
    ForwardersActions.update(selectedForwarder.id, values).then((persistedForwarder) => {
      setSelectedForwarder(persistedForwarder);
      setSubmitting(false);
      onStepComplete();
    });
  };
  const initialValues = {
    hostname: selectedForwarder.hostname,
    title: selectedForwarder.title,
    description: selectedForwarder.description
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(StyledTitle, null, "Configure Forwarder"), /* @__PURE__ */ React.createElement("p", null, "Enter some configuration details for the Forwarder running in ", /* @__PURE__ */ React.createElement("em", null, selectedForwarder.hostname), ":"), /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "hostname",
      name: "hostname",
      label: "Hostname",
      type: "text",
      value: values.hostname,
      onChange: handleChange,
      help: "Hostname where this Forwarder is running. This is automatically sent by the Forwarder.",
      required: true,
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: "Title",
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: "Meaningful name used to identify this Forwarder.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: /* @__PURE__ */ React.createElement("span", null, "Description ", /* @__PURE__ */ React.createElement("small", null, "(Optional)")),
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: "Longer description for this Forwarder."
    }
  ), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? "Saving your changes..." : "Add Forwarder inputs")))));
};
export default ConfigureForwarderStep;
